import { Box, Skeleton, SkeletonText } from "@chakra-ui/react";

interface SkeletonBarChartProps {
  horizontal?: boolean;
}
const SkeletonBarChart = ({ horizontal = false }: SkeletonBarChartProps) => {
  if (horizontal) {
    return (
      <Box height="280px" p={4}>
        {[1, 2, 3, 4, 5].map((item) => (
          <Box key={item} display="flex" alignItems="center" gap={4} mb={4}>
            <Box flex={1} display="flex" alignItems="center">
              <Skeleton
                height="24px"
                width={`${40 + Math.random() * 50}%`}
                borderRadius="4px"
              />
            </Box>
          </Box>
        ))}
      </Box>
    );
  }
  return (
    <Box
      display="grid"
      gridTemplateAreas={`"space1 bar1 space2 bar2 space3 bar3 space4" "_ _ labels labels labels __ __"`}
      gridTemplateColumns="1fr 2fr 1fr 2fr 1fr 2fr 1fr"
      alignItems="end"
      gridTemplateRows="3fr 56px">
      <Skeleton gridArea="bar1" height="240px" />
      <Skeleton gridArea="bar2" height="180px" />
      <Skeleton gridArea="bar3" height="160px" />
      <Box gridArea="labels" alignItems="center">
        <SkeletonText noOfLines={1} />
      </Box>
    </Box>
  );
};

export default SkeletonBarChart;
